import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { PATIENT_SERVICES } from '@avanta/shared/constants/patients';
import { Brain } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { SapaCard } from 'components/SapaCard';
import { ROUTES } from 'constants/routes';
import { useNavRedirect } from 'hooks/useNavRedirect';
import { useUserStore } from 'stores/user';
import { WorkplaceConflictInfo } from './components/WorkplaceConflictInfo';

export const Sapa = (): React.ReactElement => {
  const pathname = useLocation().pathname;
  const services = useUserStore(state => state.user?.activeServices);
  const { t } = useTranslation(LOCIZE_NS.SERVICES);

  useNavRedirect(pathname.includes(ROUTES.SAPA) && !services?.includes(PATIENT_SERVICES.SAPA));

  return (
    <div className="flex flex-col gap-6">
      <Card icon={Brain} title={t('SapaCard.Harassment.heading')}>
        <div className="pb-4 grid grid-cols-1 lg:grid-cols-2 items-center w-full px-0 md:px-8 lg:px-12 gap-6 md:gap-8 lg:gap-12">
          <WorkplaceConflictInfo />
          <div className="flex justify-center">
            <SapaCard className="w-full max-w-xl" />
          </div>
        </div>
      </Card>
    </div>
  );
};
